import { IDropdownStyles } from 'office-ui-fabric-react/lib/Dropdown';

export const sharedDropdownStyles: Partial<IDropdownStyles> = {
    dropdownItem: {
        selectors: {
            '@media (forced-colors: active)': {
                backgroundColor: 'Canvas',
                color: 'CanvasText',
                forcedColorAdjust: 'none',
            },
            ':hover': {
                '@media (forced-colors: active) and (prefers-color-scheme: light)': {
                    backgroundColor: 'HighlightText',
                    color: 'CanvasText',
                    forcedColorAdjust: 'none',
                },
                '@media (forced-colors: active) and (prefers-color-scheme: dark)': {
                    backgroundColor: 'CanvasText',
                    color: 'Canvas',
                    forcedColorAdjust: 'none',
                },
            },
            ':focus': {
                '@media (forced-colors: active) and (prefers-color-scheme: light)': {
                    backgroundColor: 'HighlightText',
                    color: 'CanvasText',
                    forcedColorAdjust: 'none',
                },
                '@media (forced-colors: active) and (prefers-color-scheme: dark)': {
                    backgroundColor: 'CanvasText',
                    color: 'Canvas',
                    forcedColorAdjust: 'none',
                },
            },
        },
    },
    dropdownItemSelected: {
        selectors: {
            '@media (forced-colors: active) and (prefers-color-scheme: light)': {
                backgroundColor: 'HighlightText',
                color: 'CanvasText',
                forcedColorAdjust: 'none',
            },
            '@media (forced-colors: active) and (prefers-color-scheme: dark)': {
                backgroundColor: 'CanvasText',
                color: 'Canvas',
                forcedColorAdjust: 'none',
            },
        },
    },
    dropdownItemDisabled: {
        selectors: {
            '@media (forced-colors: active)': {
                color: 'CanvasText',
                forcedColorAdjust: 'none',
            },
        },
    },
    dropdownItemSelectedAndDisabled: {
        selectors: {
            '@media (forced-colors: active) and (prefers-color-scheme: light)': {
                backgroundColor: 'HighlightText',
                color: 'CanvasText',
                forcedColorAdjust: 'none',
            },
            '@media (forced-colors: active) and (prefers-color-scheme: dark)': {
                backgroundColor: 'CanvasText',
                color: 'Canvas',
                forcedColorAdjust: 'none',
            },
        },
    },
    dropdownOptionText: {
        selectors: {
            '@media (forced-colors: active)': {
                color: 'inherit',
                backgroundColor: 'transparent',
                forcedColorAdjust: 'none',
            },
        },
    },
};
